// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import application from './application'
import home from './home'
import api from './api'
import website from './website'
import design from './design'
import quote from './quote'
import price from './price'
import discover from './discover'
import process from './process'
import map from './map'
import jobs from './jobs'
import privacy from './privacy'
import terms from './terms'
import portfolio from './portfolio'

import VueRouter from 'vue-router'

import VueContentLoading from 'vue-content-loading';

import VueSimpleSVG from 'vue-simple-svg'
Vue.use(VueSimpleSVG)

Vue.config.productionTip = false

import vScroll from 'vue-scroll'
Vue.use(vScroll)

Vue.use(VueRouter);

import VueFire from 'vuefire'
Vue.use(VueFire);



import VueGoogleAutocomplete from 'vue-google-autocomplete'
Vue.use(VueGoogleAutocomplete);

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAaOmpciY4n0zSb7CjuX5BoXdvii1WCfWk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
    
  },

})

const routes = [
  {
    path: '/application',
    name: 'application',
    component: application
  },
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/api',
    name: 'api',
    component: api
  },
  {
    path: '/website',
    name: 'website',
    component: website
  },
  {
    path: '/quote',
    name: 'quote',
    component: quote
  },
  {
    path: '/design',
    name: 'design',
    component: design
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: portfolio
  },
  {
    path: '/discover',
    name: 'discover',
    component: discover
  },
  {
    path: '/process',
    name: 'process',
    component: process
  },
  {
  path: '/map',
  name: 'map',
  component: map
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: jobs
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy
  },
  {
    path: '/terms',
    name: 'terms',
    component: terms
  },
  {
    path: '/price',
    name: 'price',
    component: price
  }
];




const router = new VueRouter ({
  routes,
  mode : 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }

});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data: {
    isShowMyModal: false
  }

})



// WEBPACK FOOTER //
// ./src/main.js